import { OneEyeService } from './api'

const krtiWebUrl = process.env.REACT_APP_WEB_BASE_URL;


export const superAdminLogin = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/user/signin`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const adminDashboard = async (req) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/dashboard/getDashboard`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const brandDashboardCount = async (brand_id) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/dashboard/brandCount/${brand_id}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const DashboardChartDetails = async (chartType, payload) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/dashboard/getAll/${chartType}`, payload)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}



export const dashBoardChart = async (chart, req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/dashboard/getAll/${chart}`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const brandChart = async (brand_id, req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/dashboard/getBrandOffers/${brand_id}`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}



export const registerBrand = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/merchant-management/createBrand`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const verifyOtp = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/merchant-management/verifyOtp`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


export const getBrandList = async (requestBody) => {
    const { offset, limit, user_id, brand_id,search,startDate ,endDate } = requestBody
    try {
        return await OneEyeService.get(`${krtiWebUrl}/merchant-management/getAllUsers?offset=${offset}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&search=${search}`, requestBody)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getDropDownList = async (requestBody) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/merchant-management/getUsersDropDownList`, requestBody)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}




export const getCustomerList = async (requestBody) => {
    const { offset, limit, user_id, brand_id,search,startDate ,endDate } = requestBody
    try {
        return await OneEyeService.get(`${krtiWebUrl}/dashboard/getAllUsers?offset=${offset}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&search=${search}`, requestBody)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const getAdminUserList = async (requestBody) => {
    const { offset, limit, user_id, brand_id,search,startDate ,endDate } = requestBody
    try {
        return await OneEyeService.get(`${krtiWebUrl}/dashboard/getAllAdminList?offset=${offset}&limit=${limit}&search=${search}`, requestBody)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}


// add admin

export const createAdmin = async (req) => {
    try {
        return await OneEyeService.post(`${krtiWebUrl}/user/registerUser`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}






export const updatebrand = async (body) => {
    try {
        return await OneEyeService.patch(`${krtiWebUrl}/merchant-management/update-brand`, body)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}














export const AdminResetPassword = async (req) => {
    try {
        let payload = {
            password: req?.oldPassword,
            newpassword: req?.newPassword,
            id:req.id
        }
        // return await OneEyeService.post(`${krtiWebUrl}/user/reset_password/${req.id}`, payload)
        return await OneEyeService.post(`${krtiWebUrl}/api/authentication/reset_password`, payload)
    } catch (error) {
        console.log(error)
        return error?.response;
    }
}


export const Counrtylist = async (req) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/merchant-management/get-countries-list`, req)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}

export const projectReport = async (reportType) => {
    try {
        return await OneEyeService.get(`${krtiWebUrl}/api/Report/type/${reportType}`)
    } catch (error) {
        console.log(error)
        return error?.response?.data
    }
}





